<!-- footer -->
<footer class="footer" style="display: none;">
  <div class="container">
    <div class="content has-text-centered">
      <p>
        Made with <3 by <a href="https://bantupay.org/">BantuPay</a>
      </p>
    </div>
  </div>
</footer>